import $ from 'jquery';
jQuery.noConflict();

export function jsEventLog(eventId, msg, data) {
    $.ajax({
        type: 'GET',
        url: '/_edreamz/checkout/log-event.php',
        data: {
            eventid: eventId,
            message: msg,
            jsondata: data
        }
    });
}